// The "all options" data is loaded via the useAllOptions hook in the new
// consumer app. This module previously provided a class-based singleton for the
// legacy app and is retained only as a null default export for callers that
// still guard on its (now always-null) instance.
export default null;
